export const GET_EMPLOYEES_DATA = 'GET_EMPLOYEES_DATA';
export const FETCH_DROPDOWN_DATAS = 'FETCH_DROPDOWN_DATAS';
export const STATUS_UPDATE = "STATUS_UPDATE";
export const GENERATE_ONBOARDING_LINK = "GENERATE_ONBOARDING_LINK";
export const DEPARTMENT_DROPDOWN = "DEPARTMENT_DROPDOWN";
export const TEAM_DROPDOWN = "TEAM_DROPDOWN";
export const ROLE_DROPDOWN = "ROLE_DROPDOWN";
export const REPORTING_MANAGER_DROPDOWN = "REPORTING_MANAGER_DROPDOWN";
export const CITIES_DROPDOWN = "CITIES_DROPDOWN";
export const ZONES_DROPDOWN = "ZONES_DROPDOWN";
export const AREAS_DROPDOWN = "AREAS_DROPDOWN";
export const ASSIGN_LOCATION = "ASSIGN_LOCATION";
export const ASSIGN_REPORTEE = "ASSIGN_REPORTEE";
export const USER_LOCATION_MAPPING = "USER_LOCATION_MAPPING";
export const USER_TEAM_MAPPING = "USER_TEAM_MAPPING";
export const DELETE_USER_MAPPING = "DELETE_USER_MAPPING";